import { OTA_PricedCoverage } from "./ota_pricedcoverage.model";

export class OTA_VehAvailInfo {
    public pricedCoverages = new Array<OTA_PricedCoverage>();
}